// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2hlda","col":"CardReaderDesc_col__SKX19","label":"CardReaderDesc_label__bKAN6"};